import { jwtDecode } from "jwt-decode";
import { TokenType } from "../models/types/userTypes";

const TOKEN = "token";
const FAVORITES = "favorites";

export const setTokenInLocalStorage = (encreptedToken: string) => {
  return localStorage.setItem(TOKEN, encreptedToken);
};

export const getUser = () => {
  const token = localStorage.getItem(TOKEN);
  if (!token) return null;
  const user: TokenType = jwtDecode(token);
  return user;
};

export const getToken = () => localStorage.getItem(TOKEN);

export const removeToken = () => localStorage.removeItem(TOKEN);

// Favorites localStorage functions for guest users
export const getFavorites = (): string[] => {
  const favorites = localStorage.getItem(FAVORITES);
  return favorites ? JSON.parse(favorites) : [];
};

export const addToFavorites = (cardId: string) => {
  const favorites = getFavorites();
  if (!favorites.includes(cardId)) {
    favorites.push(cardId);
    localStorage.setItem(FAVORITES, JSON.stringify(favorites));
  }
};

export const removeFromFavorites = (cardId: string) => {
  const favorites = getFavorites();
  const updatedFavorites = favorites.filter((id) => id !== cardId);
  localStorage.setItem(FAVORITES, JSON.stringify(updatedFavorites));
};

export const isFavorite = (cardId: string): boolean => {
  const favorites = getFavorites();
  return favorites.includes(cardId);
};
